var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { BaseProvider } from './base';
import { JobProvider, JobState, JobType } from './job';
import { AuthProvider } from './auth';
import { API } from './api';
import { EventName, Events } from '../utils/events';
var TRACKABLE_JOB_TYPES = [
    JobType.IncrementalTrain,
    JobType.Retrain,
    JobType.Optimize,
    JobType.Freeze,
    JobType.Train,
    JobType.AnomalyHiFi,
    JobType.BrainExport
];
var JOBS_POLLING_INTERVAL_FREQUENT_MS = 5000;
var JOBS_POLLING_INTERVAL_INFREQUENT_MS = 30000;
export var STATE_DESCRIPTION_RECALCULATE = 'Recalculating Accuracy';
var pollJobsTimeout;
var TrackableJobProvider = /** @class */ (function (_super) {
    __extends(TrackableJobProvider, _super);
    function TrackableJobProvider(api, jobProvider, events, authProvider) {
        var _this = _super.call(this) || this;
        _this.api = api;
        _this.jobProvider = jobProvider;
        _this.events = events;
        _this.authProvider = authProvider;
        _this.isLoggedInSubscription = _this.authProvider.isAuthenticatedSubscription.subscribe(function (isLoggedIn) {
            _this.isLoggedIn = isLoggedIn;
            if (_this.isLoggedIn) {
                _this.restartJobPolling();
            }
            else {
                _this.stopPollJobs();
            }
        });
        return _this;
    }
    /**
     * Start the event loop for periodically loading data about
     * all the current user or organization jobs
     */
    TrackableJobProvider.prototype.initializeJobPolling = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (pollJobsTimeout) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.pollJobs()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Stop and start the event loop for periodically loading data about
     * all the current user or organization jobs. This is used to ensure the
     * latest job states are loaded right after a new job is kicked off. It
     * will also force more frequent polling when running jobs are detected
     */
    TrackableJobProvider.prototype.restartJobPolling = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.stopPollJobs();
                        return [4 /*yield*/, this.pollJobs()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Start an event loop to periodically load the state of all user boost jobs
     */
    TrackableJobProvider.prototype.pollJobs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var updatedJobs, pollInterval;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Don't start polling if we're not logged in.
                        // Successfully logging in will cause a restartJobPolling() call.
                        if (!this.isLoggedIn) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.jobProvider.loadJobs(TRACKABLE_JOB_TYPES)];
                    case 1:
                        updatedJobs = _a.sent();
                        return [4 /*yield*/, this.loadStatesForPolledJobs(updatedJobs)];
                    case 2:
                        _a.sent();
                        pollInterval = this.getJobPollingIntervalFromJobStates(updatedJobs);
                        pollJobsTimeout = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                            var e_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, this.pollJobs()];
                                    case 1:
                                        _a.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        e_1 = _a.sent();
                                        console.error('Job poll failed');
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); }, pollInterval);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Stop the event loop for periodically loading the state of all user boost jobs
     */
    TrackableJobProvider.prototype.stopPollJobs = function () {
        if (pollJobsTimeout) {
            clearTimeout(pollJobsTimeout);
        }
        pollJobsTimeout = undefined;
    };
    TrackableJobProvider.prototype.getJobPollingIntervalFromJobStates = function (jobs) {
        for (var _i = 0, jobs_1 = jobs; _i < jobs_1.length; _i++) {
            var job = jobs_1[_i];
            if (!this.jobProvider.isJobDone(job.state) || job.state != job.previousState) {
                // At least one job running or recently changed state; poll frequently
                return JOBS_POLLING_INTERVAL_FREQUENT_MS;
            }
        }
        // Jobs are dormant; poll infrequently
        return JOBS_POLLING_INTERVAL_INFREQUENT_MS;
    };
    /**
     * Publish events associated with the latest polled job data
     */
    TrackableJobProvider.prototype.loadStatesForPolledJobs = function (updatedJobs) {
        return __awaiter(this, void 0, void 0, function () {
            var jobsEventData, _i, updatedJobs_1, job;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        jobsEventData = {
                            jobs: updatedJobs
                        };
                        this.events.publish(EventName.TrackableJobsPolled, jobsEventData);
                        _i = 0, updatedJobs_1 = updatedJobs;
                        _a.label = 1;
                    case 1:
                        if (!(_i < updatedJobs_1.length)) return [3 /*break*/, 4];
                        job = updatedJobs_1[_i];
                        if (!(!this.jobProvider.isJobDone(job.state) || job.state != job.previousState)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.loadStateForJob(job)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Load boost state for each valid job type in the dataset
     */
    TrackableJobProvider.prototype.loadJobStates = function (datasetIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var typeToJobMap, jobType;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.jobProvider.loadDatasetJobs(datasetIdentifier, TRACKABLE_JOB_TYPES)];
                    case 1:
                        typeToJobMap = _a.sent();
                        for (jobType in typeToJobMap) {
                            this.loadStateForJob(typeToJobMap[jobType]);
                        }
                        return [2 /*return*/, typeToJobMap];
                }
            });
        });
    };
    /**
     * Publish events associated with the state of the specified job
     *
     * @param job The job being processed
     */
    TrackableJobProvider.prototype.loadStateForJob = function (job) {
        var jobEventData = this.jobProvider.getJobEventData(job);
        this.events.publish(EventName.TrackableJobUpdated, jobEventData);
        switch (job.state) {
            case JobState.READY:
            case JobState.WAITING:
                this.events.publish(EventName.TrackableJobWaiting, jobEventData);
                break;
            case JobState.PROCESSING:
                if (job.stateDescription == STATE_DESCRIPTION_RECALCULATE) {
                    this.events.publish(EventName.BoostRecalculating, jobEventData);
                }
                else {
                    this.events.publish(EventName.TrackableJobProcessing, jobEventData);
                }
                break;
            case JobState.CANCEL_REQUESTED:
            case JobState.CANCELING:
                this.events.publish(EventName.TrackableJobCanceling, jobEventData);
                break;
            case JobState.ERROR:
                // This used to only fire if a job you triggered during the session errored out.
                // This has been disabled so we can persist the 'fail' state until it's explicitly dismissed in the job pages.
                this.events.publish(EventName.TrackableJobFailed, jobEventData);
                break;
            case JobState.DONE:
                this.events.publish(EventName.TrackableJobFinished, jobEventData);
                break;
            case JobState.CANCELED:
                this.events.publish(EventName.TrackableJobCanceled, jobEventData);
                break;
        }
    };
    TrackableJobProvider.prototype.notifyJobRequestFailed = function (datasetIdentifier, jobType) {
        var jobEventData = {
            jobIdentifier: null,
            type: jobType,
            datasetIdentifier: datasetIdentifier,
            state: JobState.ERROR
        };
        this.events.publish(EventName.TrackableJobFailed, jobEventData);
    };
    TrackableJobProvider.prototype.isRelevantJob = function (datasetIdentifierFromComponent, datasetIdentifierFromJob, jobTypeFromComponent, jobTypeFromJob) {
        if (datasetIdentifierFromComponent == undefined || datasetIdentifierFromJob == undefined) {
            return false;
        }
        return datasetIdentifierFromComponent === datasetIdentifierFromJob && jobTypeFromComponent === jobTypeFromJob;
    };
    TrackableJobProvider.prototype.isProgressIndeterminate = function (jobType) {
        if (jobType == JobType.BrainExport) {
            return true;
        }
        return false;
    };
    TrackableJobProvider.prototype.dismiss = function (jobIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.jobProvider.dismiss(jobIdentifier)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TrackableJobProvider.prototype.isBrainBusy = function (datasetIdentifier) {
        return this.jobProvider.isJobRunningForDataset(datasetIdentifier, TRACKABLE_JOB_TYPES);
    };
    TrackableJobProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [API,
            JobProvider,
            Events,
            AuthProvider])
    ], TrackableJobProvider);
    return TrackableJobProvider;
}(BaseProvider));
export { TrackableJobProvider };
//# sourceMappingURL=trackable-job.js.map


// WEBPACK FOOTER //
// ./src/providers/trackable-job.ts.pre-build-optimizer.js